module.exports = __webpack_public_path__ + "img/fondo-konecta-mobile.60932bf0.png";